import { cn } from '~/utils/tailwind-utils'

export function SplitsTeamsWordmark({ size = 'md' }: { size?: 'sm' | 'md' }) {
  return (
    <div className="flex items-center space-x-2">
      <div
        className={cn(
          'font-medium text-blue-500',
          size === 'sm' && 'text-xs',
          size === 'md' && 'text-base',
        )}
      >
        Splits
      </div>
    </div>
  )
}
